import React, { useEffect, useState, useRef } from 'react';
import './courseAnimationBar.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveContentTabIndex } from '../../../../C2wStore/actions';
import { useNavigate } from 'react-router';
import { Link } from 'react-scroll';
import { Bounce, toast, ToastContainer } from 'react-toastify';

function C2wCourseAnimationBar({ courseData, handleIndexRef, handlePopup }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const tempIndex = useSelector((state) => state.data.activeContentTabIndex);
  const [toastFlag, setToastFlag] = useState(false)

  /**
 * @state activeIndex
 * @function handleActiveIndex
 * @author Vishal Lohbande
 *
 * Description:
 * - Maintains the currently active index in component state.
 * - `handleActiveIndex` function:
 *   - Calls an external `handleIndexRef` with the provided `index`.
 *   - Uses the result to dispatch an action `setActiveContentTabIndex` to update global state.
 *   - Updates the local `activeIndex` state with the new active index.
 *
 * Usage:
 * - Used to track and update which tab or section is currently active both locally and in a global store.
 *
 * Notes:
 * - Ensure `handleIndexRef` returns a valid index before dispatching and updating state.
 * - The dispatched action `setActiveContentTabIndex` presumably updates a Redux or context store.
 */
  const [activeIndex, setActiveIndex] = useState(0)
  const handleActiveIndex = (index) => {
    dispatch(setActiveContentTabIndex(index))
    setActiveIndex(index)
  }

  /**
 * @effect Sync Active Index with External `tempIndex`
 * @author Vishal Lohbande
 *
 * Description:
 * - React `useEffect` hook that updates the local `activeIndex` state whenever
 *   the external `tempIndex` value changes.
 *
 * Usage:
 * - Keeps the local component state `activeIndex` in sync with an external
 *   state or prop `tempIndex`.
 *
 * Notes:
 * - This ensures consistent active tab/section highlighting if `tempIndex` is
 *   updated from outside this component.
 */
  useEffect(() => {
    setActiveIndex(tempIndex)
  }, [tempIndex])

  const menuItems = [
    "Content",
    "Things included",
    "Videos",
    "Assignments",
    "Quiz",
    "Analytics",
    "Reviews",
    'Certification',
    "Rules & Regulations",
  ];

  const notify = () => {
    toast.dismiss(); // clear existing toasts 
    const url = window.location.href;
    navigator.clipboard.writeText(url)
      .then(() => {
        toast.success('link copied')
      });

  }

  /**
 * @constant windowWidth, setWindowWidth
 * @author Vishal Lohbande
 *
 * Description:
 * - Tracks the current width of the browser window.
 * - Initializes state with `window.innerWidth`.
 * - Sets up an event listener for the `resize` event on the window object.
 * - Updates `windowWidth` state whenever the window is resized.
 * - Cleans up the event listener on component unmount to prevent memory leaks.
 *
 * Usage:
 * - Useful for responsive UI components that need to adapt based on window size.
 *
 * Notes:
 * - This hook only adds the resize listener once on mount, due to the empty dependency array.
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const swiperRef = useRef(null);
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(activeIndex);
    }
  }, [activeIndex]);

  return (
    <div className='C2wCourseAnimationBar_ctn'
      style={{
        height: courseData?.type !== 'Online' ? '70px' : null,
        marginTop: courseData?.type === 'Offline' ? '0px' : null

      }}>
      {windowWidth > 620 &&
        <div className='C2wCourseAnimationBar_heading_ctn'>
          <img src='/assets/images/landing/c2w-logo-full.svg' alt='navbar-logo' onClick={() => navigate('/')} />
          <div className='C2wCourseAnimationBar_heading_title'>{courseData?.courseTitle}</div>
          <div className='C2wCourseAnimationBar_heading_fees' 
          style={{
            alignItems : courseData?.type === 'Online' ? null : 'center',
            width : courseData?.type === 'Online' ? null : 'auto'

          }}
          >
            {`₹ ${courseData?.fees}`}
              <span>{`+${courseData?.gst}% GST`}</span>
                { courseData?.type === 'Offline' &&
          <div className='C2wCourseBuy_div'>
            <button onClick={handlePopup}>
              {'Register Now'}
            </button>
          </div>
          }
          </div>
            

        </div>
      }
      {courseData?.type === 'Online' &&
        <div className='C2wCourseAnimationBar_content_slider_ctn'>

          <div className='C2wCourseAnimationBar_content_slider'>
            {courseData && courseData?.type === 'Online' &&
              <div className='C2wCourseContentSlider'>
                <Swiper pagination={{
                  "clickable": true
                }} className="mySwiper"
                  onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                    dispatch(setActiveContentTabIndex(swiper.activeIndex))
                  }}
                  is
                  breakpoints={{
                    360: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    1260: {
                      slidesPerView: 8.2,
                      spaceBetween: 25,
                    },
                    1340: {
                      slidesPerView: 5.9,
                      spaceBetween: 90,
                    },
                    1366: {
                      slidesPerView: 5.9,
                      spaceBetween: 70,
                    },
                    1440: {
                      slidesPerView: 9,
                      spaceBetween: 25,
                    },

                    1536: {
                      slidesPerView: 7,
                      spaceBetween: 80,
                    },

                    1540: {
                      slidesPerView: 7,
                      spaceBetween: 80,
                    },
                    1920: {
                      slidesPerView: 7,
                      spaceBetween: 15,
                    },
                  }}
                >
                  {menuItems && menuItems?.map((str, index) => (
                    <SwiperSlide>
                      <Link onClick={() => {
                        dispatch(setActiveContentTabIndex(index));
                        handleActiveIndex(index)
                      }}
                        className={index === activeIndex ? `C2wContentBarActive_div` : 'C2wContent_div'}
                        to={`section${index}`}
                        smooth={true}
                        duration={500}
                        offset={index === 0 ? -500 : -160}
                        containerId='C2wCourseDetailsContainer'
                      >{str}</Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            }
          </div>

          {(windowWidth > 620 && courseData?.type === 'Online') &&
            <div className='C2wCourseAnimationBar_content_btn_hld'>
              <div className='C2wCourseBuy_div'>
                <button onClick={handlePopup}>
                  {'Register Now'}
                </button>

              </div>
            </div>
          }
        </div>
      }

    </div>
  )
}

export default C2wCourseAnimationBar;
